import SocialMedia01 from "@/components/SocialMedia/components/SocialMedia01";
// types
import { TMainPageLayoutV3 } from "../type";


const MNPG061 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG061.rendered: ", props);


    return (
        <SocialMedia01
            payload={props.template?.languageVersions}
            className="social-icon d-flex align-items-center"
        />
    )
}

export default MNPG061;
